import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { cloneDeep } from "lodash";
import RoleService from "services/RoleService";
import Utils from "utils";
import openNotification from "utils/notification";

export const getAllRole = createAsyncThunk(
  "role/getAllRole",
  async (_, { rejectWithValue }) => {
    try {
      const response = await RoleService.getAllRole();
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const createRole = createAsyncThunk(
  "role/createRole",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await RoleService.createRole(payload);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const updateRole = createAsyncThunk(
  "role/updateRole",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await RoleService.updateRole(payload);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const deleteRole = createAsyncThunk(
  "role/deleteRole",
  async (data, { rejectWithValue }) => {
    try {
      const { id, onSuccess } = data;
      const response = await RoleService.deleteRole(id);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

const initialState = {
  loading: false,
  roleOptionList: [],
};
export const RoleSlice = createSlice({
  name: "role",
  initialState,
  reducers: {
    showLoading: (state) => {
      state.loading = true;
    },
    setRole: (state, action) => {
      state.roleOptionList = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllRole.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllRole.fulfilled, (state, action) => {
        state.loading = false;
        state.roleOptionList = action.payload;
      })
      .addCase(getAllRole.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(createRole.pending, (state) => {
        state.loading = true;
      })
      .addCase(createRole.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(createRole.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(updateRole.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateRole.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateRole.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(deleteRole.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteRole.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(deleteRole.rejected, (state, action) => {
        state.loading = false;
      })
      ;
  },
});

export const { showLoading, setRole } = RoleSlice.actions;

export default RoleSlice.reducer;
